import _ from 'lodash'

export function cleanTenderTypes (settingsBlob) {
  const tenderTypes = _.get(settingsBlob, 'tenderTypes.types', [])
  const kioskAvailableTenderTypes = ['1', '4', '5', '6', '7', '8']
  tenderTypes.forEach(tenderType => {
    if (!tenderType.hasOwnProperty('availableOnKiosk') ||
      !kioskAvailableTenderTypes.includes(tenderType.id)) {
      tenderType.availableOnKiosk = false
    }
  })
}
